import React from 'react';
import { Route } from 'react-router-dom';
import ParameterForm from './ParameterForm';
import ParameterList from './ParameterList';
import RouteMenu from 'mrf/view/MenuRoute';
import path from 'path';

export default function Parameter({ match }) {
    return (
        <RouteMenu match={match} indexComponent={ParameterList}>
            <Route path={path.join(match.url, 'edit/:id')} component={ParameterForm} />
        </RouteMenu>
    );
}